"use client";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown, Search, Calendar as CalendarIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import ReservationListTable from "@/components/reservation/reservation-list/reservation-list-table";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";
import { useEffect, useState } from "react";
import { useSearch } from "@/hooks/useSearch";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { useSelector } from "react-redux";
import { format, subYears, addYears } from "date-fns";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

function ListTabs({ data, perPage, setPerPage, setStartTime, setEndTime, setSearch }) {
  const [searchText, setSearchText] = useState("");
  const { getLoading } = useSelector((state) => state.reservation.reservation);


  const defaultStart = subYears(new Date(), 1);
  const defaultEnd = addYears(new Date(), 1);

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);

  // Handle Date Changes
  const handleStartChange = (date) => {
    setStartDate(date);
    setStartTime?.(format(date, "yyyy-MM-dd"));
  };

  const handleEndChange = (date) => {
    setEndDate(date);
    setEndTime?.(format(date, "yyyy-MM-dd"));
  };

  // const searchData = useSearch(data, searchText, ["name", "description"], 300);
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(searchText);
    }, 900);

    return () => clearTimeout(handler);
  }, [searchText]);


  return (
    <TabsContent value="list">
      <div className="mt-5">
        {/* Search & Filters */}
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          {/* Search Input */}
          <div className="w-[260px]">
            <div className="relative">
              <Search size={18} className="text-cwhite3 absolute top-2 left-2" />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
          </div>

          {/* Filters & Actions */}
          <div className="flex flex-col gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center text-white">
              {/*  Start Date */}
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    className="w-[160px] justify-start text-left font-normal bg-cblack3 border border-gray-600 text-cwhite2"
                  >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {startDate ? format(startDate, "yyyy-MM-dd") : "Start Date"}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0 bg-cblack3">
                  <Calendar
                    className={'text-white'}
                    mode="single"
                    selected={startDate}
                    onSelect={handleStartChange}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>

              <span>to</span>

              {/* End Date */}
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    className="w-[160px] justify-start text-left font-normal bg-cblack3 border border-gray-600 text-cwhite2"
                  >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {endDate ? format(endDate, "yyyy-MM-dd") : "End Date"}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0 bg-cblack3">
                  <Calendar
                    mode="single"
                    selected={endDate}
                    onSelect={handleEndChange}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>

              {/*  Export */}
              <Button className="bg-cblack3 border border-gray-600 text-cwhite2">
                <FileDown /> Export
              </Button>

              {/*  Per Page */}
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="mt-5 w-full ">
          {getLoading ? (
            <OnlyTableSekeleton header={false} />
          ) : (
            <ReservationListTable data={data} />
          )}
        </div>
      </div>
    </TabsContent>
  );
}

export default ListTabs;
